// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { MailModule } from './apps/mail/mail.module';
import { ECommerceModule } from './apps/e-commerce/e-commerce.module';
import { UserManagementModule } from './user-management/user-management.module';
import { MyPageComponent } from './my-page/my-page.component';
import { CustomersService } from './services/customers.service';
import { DrawingService } from './services/drawing.service';
import { ProjectService } from './services/project.service';
import { CustomerSurveyService } from './services/customer-survey.service';
import { MasterEntityService } from './services/masterentity.service';
import { ElectricalService } from './services/electrical.service';
import { CalculationService } from './qnt-calculation/services/calculation.service';
import { ParentService } from './qnt-calculation/services/parent.service';
import { ProjectQntService } from './qnt-calculation/services/projectQnt.service';
import { UserQntService } from './qnt-calculation/services/userQnt.service';

@NgModule({
  declarations: [MyPageComponent],
  exports: [],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    PartialsModule,
    MailModule,
    ECommerceModule,
    UserManagementModule,
  ],
  providers: [CustomersService, DrawingService, ProjectService, MasterEntityService, CustomerSurveyService, ElectricalService, CalculationService, ParentService, ProjectQntService, UserQntService]
})
export class PagesModule {
}
